import React from 'react'
import SVG from 'react-inlinesvg';
import {Flex} from '/app/src/component'

class TabIcons extends React.Component {
    render() {
        const size = '32px'
        let blue = '#4ec1e0'
        let grey = '#c6c6c6'

        let {active, index} = this.props

        let fill = grey
        if(active === index){
            fill = blue
        }

        return <Flex center onClick={()=>this.props.onClick(index)} h='70px' shrink={0}>
                <SVG cacheGetRequests={true} style={{fill: fill, width: size, height: size}} src={this.props.svgSrc}/>
        </Flex>
    }
}

export default TabIcons;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/Conversation/TabIcon/index.js